export const SELECT_EMPLOYEE = "SELECT_EMPLOYEE";
export const UNSELECT_EMPLOYEE = "UNSELECT_EMPLOYEE";
export const RESET_STATE = "RESET_STATE";
